;(function() {
    var

    //
    //init
    //
    init = function() {
        if ($('.layout-organization-map').length > 0) {
            loadGoogleMap();
        }
    },

    //
    // get the organization locations
    // TEMPORARILY REMOVED
    //
    // getLocations = function() {
    //     return new Promise(function(resolve, reject) {
    //         $.get('/organization-map/locations', function(res) {
    //             resolve(res);
    //         });
    //     });
    // },

    //
    // get the organization location
    //
    getLocation = function(organization_id) {
        return new Promise(function(resolve, reject) {
            $.post('/gallery/mapLocation/' + organization_id, function(res) {
                resolve(res);
            });
        });
    },

    //
    // load the google map
    //
    loadGoogleMap = function() {

        // get the location
        getLocation($('#map_wrapper').attr('data-organization-id'))
            .then(function(location) {
                // get LatLng for google maps
                var latLng = new google.maps.LatLng(location.location_latitude, location.location_longitude);

                var mapOptions = {
                    center: latLng,
                    zoom: 4,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                }

                // create the map
                this.map = new google.maps.Map(document.getElementById("map_canvas"), mapOptions);

                // create the map marker
                var marker = new google.maps.Marker({
                    position: latLng
                });

                // add the marker to the map
                marker.setMap(this.map);

                //build the popop tooltip
                var info = "<div class='info_content'>";
                info += "<h3>";
                if (location.website) {
                    info += '<a href="' + location.website + '" target="_blank">' + location.name + "</a>";
                } else {
                    info += location.name;
                }
                info += "</h3>";
                info += "<p>" + location.location + "</p>"
                info += "</div>";

                var infowindow = new google.maps.InfoWindow({content: info});

                marker.addListener('click', function() {
                    infowindow.open(map, marker);
                });





                // //build the title
                // var title = "";
                // if (location.website) {
                //     title += '<a href="' + location.website + '" target="_blank">' + location.name + "</a>";
                // } else {
                //     title += location.name;
                // }

                // title += "<p>" + location.location + "</p>"

                // // create the map marker
                // var marker = new google.maps.Marker({
                //     position: latLng,
                //     title: title
                // });

                // // add the marker to the map
                // marker.setMap(this.map);

//===================                
                // var map;
                // var bounds = new google.maps.LatLngBounds();
                // var mapOptions = {
                //     mapTypeId: 'roadmap',
                //     zoom: 4
                // };
                                
                // // Display a map on the page
                // map = new google.maps.Map(document.getElementById("map_canvas"), mapOptions);
                // map.setTilt(45);
                    
                // // Multiple Markers
                // var markers = [
                //     [location.name, location.location_latitude,location.location_longitude]
                // ];

                // var website = location.name;
                // if (location.website) {
                //     website = '<a href="' + location.website + '" target="_blank">' + location.name + '</a>';
                // }
                                    
                // // Info Window Content
                // var infoWindowContent = [
                //     ['<div class="info_content">' +
                //     '<h3>' + website + '</h3>' +
                //     '<p>' + location.location + '</p></div>'],
                // ];
                    
                // // Display multiple markers on a map
                // var infoWindow = new google.maps.InfoWindow(), marker, i;
                
                // // Loop through our array of markers & place each one on the map  
                // for( i = 0; i < markers.length; i++ ) {
                //     var position = new google.maps.LatLng(markers[i][1], markers[i][2]);
                //     bounds.extend(position);
                //     marker = new google.maps.Marker({
                //         position: position,
                //         map: map,
                //         title: markers[i][0]
                //     });
                    
                //     // Allow each marker to have an info window    
                //     google.maps.event.addListener(marker, 'click', (function(marker, i) {
                //         return function() {
                //             infoWindow.setContent(infoWindowContent[i][0]);
                //             infoWindow.open(map, marker);
                //         }
                //     })(marker, i));

                //     // Automatically center the map fitting all markers on the screen
                //     map.fitBounds(bounds);
                // }

                // // Override our map zoom level once our fitBounds function runs (Make sure it only runs once)
                // var boundsListener = google.maps.event.addListener((map), 'bounds_changed', function(event) {
                //     //this.setZoom(15);
                //     this.setZoom(4);
                //     google.maps.event.removeListener(boundsListener);
                // });
            });
    }

    //call init
    $(document).ready(init);

})();